/* @flow */
import React, { Component } from 'react';
import { Layout } from 'antd';
import Animate from 'rc-animate';
import { GlobalHeader } from '@/components';
import styles from './Header.module.pcss';

type Props = {
  autoHideHeader: boolean,
  isMobile: boolean,
  isCollapsed: boolean,
  settings: SettingsT,
  handleMenuCollapse: (isCollapsed: boolean) => void,
};

type State = {
  visible: boolean,
};

const { Header } = Layout;

export default class HeaderLayout extends Component<Props, State> {
  state = {
    visible: true,
  };

  isTicking: boolean;
  oldScrollTop: number;

  static getDerivedStateFromProps(props: Props, state: State) {
    if (!props.settings.autoHideHeader && !state.visible) {
      return {
        visible: true,
      };
    }
    return null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handScroll, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handScroll);
  }

  getHeadWidth = () => {
    const {
      isMobile,
      isCollapsed,
      settings: { fixedHeader, layout, siderWidth = 256 },
    } = this.props;
    if (isMobile || !fixedHeader || layout === 'topmenu') {
      return '100%';
    }
    return isCollapsed ? 'calc(100% - 100px)' : `calc(100% - ${siderWidth}px)`;
  };

  handScroll = () => {
    const { autoHideHeader } = this.props;
    const { visible } = this.state;
    if (!autoHideHeader) {
      return;
    }
    const scrollTop = (document: any).body.scrollTop + (document: any).documentElement.scrollTop;
    if (!this.isTicking) {
      this.isTicking = true;
      requestAnimationFrame(() => {
        if (this.oldScrollTop > scrollTop) {
          this.setState({
            visible: true,
          });
        } else if (scrollTop > 300 && visible) {
          this.setState({
            visible: false,
          });
        } else if (scrollTop < 300 && !visible) {
          this.setState({
            visible: true,
          });
        }
        this.oldScrollTop = scrollTop;
        this.isTicking = false;
      });
    }
  };

  render() {
    const { handleMenuCollapse, settings } = this.props;
    const { visible } = this.state;
    const width = this.getHeadWidth();
    const HeaderView = visible ? (
      <Header
        style={{ padding: 0, zIndex: 5, width }}
        className={settings.fixedHeader ? styles.fixedHeader : ''}
        data-cy="base-layout-header"
      >
        <GlobalHeader {...this.props} onCollapse={handleMenuCollapse} />
      </Header>
    ) : null;
    return (
      <Animate component="" transitionName="fade">
        {HeaderView}
      </Animate>
    );
  }
}
